import { GoogleSheetsConnectionStatus } from './GoogleSheetsConnectionManager';

interface ConnectedToGoogleSheetsProps {
  status: GoogleSheetsConnectionStatus;
}

const ConnectedToGoogleSheets = ({ status }: ConnectedToGoogleSheetsProps) => {
  return <p>✓ Connected to Google Sheets {status?.email && `(${status.email})`}</p>;
};

export default ConnectedToGoogleSheets;
